// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"78d3b7ed","409":"9715218e","453":"d2623fc0","644":"58d8d7d4","667":"55150d7c","767":"7adefeab","895":"a2841c88"}[chunkId] + ".chunk.js";
};